import { authHeader,check419 } from "../helpers";

export const hospitalService = {
    add,
    getList,
    getById,
    update,
    delete: _delete,
    getSuggestionList,
    updateHospitalList,
    mergeHospitalList,
    hospitalListForMerge
};

function hospitalListForMerge(hospitalList) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(hospitalList),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "hospitals/hospitalListForMerge",
        requestOptions
    ).then(handleResponse);
}

function mergeHospitalList(hospitalList) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(hospitalList),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "hospitals/mergeHospitals",
        requestOptions
    ).then(handleResponse);
}

function updateHospitalList(hospitalList) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(hospitalList),
    };

    return fetch(
        process.env.REACT_APP_APIURL + "hospitals/deleteAndMoveHospitalInAssociates",
        requestOptions
    ).then(handleResponse);
}

function getList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"hospitals/getHospitals", requestOptions).then(handleResponse)
        .then(kitsList => {
            return kitsList;
        });
}

function getSuggestionList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"hospitals/hospitalListForSuggestion", requestOptions).then(handleResponse)
        .then(kitsList => {
            return kitsList;
        });
}

function getById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_APIURL+`hospitals/getHospital/${id}`, requestOptions).then(handleResponse);
}

function add(kitInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(kitInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"hospitals/saveHospitals", requestOptions).then(handleResponse);
}

function update(kitInfo) {
    const requestOptions = {
        method: "POST",
        headers: {...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(kitInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"hospitals/updateHospitals", requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(id)
    };

    return fetch(process.env.REACT_APP_APIURL+"hospitals/deleteHospitals", requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        //const data = text;
        if (!response.ok) {
            if (response.status === 400) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
                const error = (data && data.data.errors) || response.statusText;
                return Promise.reject(error);
            } else if(response.status === 419){
                check419();
            }

            // const error = (data && data.message) || response.statusText;
            // return Promise.reject(error);
        }

        return data;
    });
}